<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <div class="grid w-full gap-6 pt-5 sm:grid-cols-2">
    <mat-form-field appearance="outline" class="fuse-mat-no-subscript">
      <mat-label>Start Date</mat-label>
      <input matInput [(ngModel)]="data.startDate" [matDatepicker]="startpicker" />
      <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
      <mat-datepicker #startpicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="fuse-mat-no-subscript">
      <mat-label>End Date</mat-label>
      <input matInput [(ngModel)]="data.endDate" [matDatepicker]="endpicker" />
      <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
      <mat-datepicker #endpicker></mat-datepicker>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions>
  <ng-container *ngFor="let action of data.actions || []; first as isFirst">
    <button
      *ngIf="!isFirst; else First"
      class="w-40 ml-4"
      mat-flat-button
      [color]="'default'"
      (click)="onAction(action)">
      {{ action }}
    </button>
    <ng-template #First>
      <button
        class="w-40"
        mat-flat-button
        color="primary"
        (click)="onAction(action)"
        [disabled]="!data.validFn(data.startDate, data.endDate)">
        {{ action }}
      </button>
    </ng-template>
  </ng-container>
</div>
